import React, { Component } from 'react';
import ErrorModal from '../../Components/ErrorModal/ErrorModal';
import KpisAreas from '../../Components/Kpis-Areas/Kpis-Areas';
import { Configurations } from '../../Utils/Configurations';
import axios from 'axios';
import moment from 'moment';
import update from 'immutability-helper';
import './Kpis.scss';


class Kpis extends Component {
    constructor(props) {
        super(props);

        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.carregarKpis = this.carregarKpis.bind(this);
        this.carregarTodosKpisPublicacoes = this.carregarTodosKpisPublicacoes.bind(this);
        this.carregarKpisMarketing = this.carregarKpisMarketing.bind(this);
        this.carregarKpisRelacionamento = this.carregarKpisRelacionamento.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            kpisPublicacoes: [],
            kpisMarketing: [],
            kpisRelacionamento: [],
            hasError: false,
            errorMessage: '',
            listaKpisPublicacoes: [],
            listaKpisMarketing: [],
            listaKpisRelacionamento: []
        }

        this.mockKpisPublicacoes = [
            {
                id: 3,
                periodico: "BSP",
                cor: "primary",
                titulo: "Acessos",
                flagAcessos: true,
                descricao: "quantidade de acessos em todas as editorias (pessoas)",
                sigla: "BS",
                isLoading: false,
                urlApi: "/kpi/acessos/periodico/BS",

            },
            {
                id: 3,
                periodico: "TC",
                cor: "danger",
                titulo: "Acessos",
                flagAcessos: true,
                descricao: "total de acessos em todas as editorias (pessoas)",
                sigla: "TC",
                isLoading: false,
                urlApi: "/kpi/acessos/periodico/TC"
            },
            {
                id: 7,
                periodico: "TC",
                cor: "danger",
                titulo: "Acessos na edição deste mês",
                flagAcessos: true,
                descricao: "",
                sigla: "TC",
                isLoading: false,
                urlApi: "/kpi/acessos/periodico/TC/edicao-do-mes"
            },
            {
                id: 3,
                periodico: "RDEZ",
                cor: "warning",
                titulo: "Acessos",
                flagAcessos: true,
                descricao: "acessos aos conteúdos",
                sigla: "RD",
                urlApi: "/kpi/acessos/periodico/RD",
                isLoading: false
            },
            {
                id: 4,
                periodico: "PODCASTS",
                cor: "info",
                titulo: "Acessos",
                flagAcessos: true,
                descricao: "quantidade de acessos/quantidade de episódios publicados no período",
                urlApi: "/kpi/acessos/podcasts",
                isLoading: false

            },
        ]

        this.mockKpisMarketing = [
            {
                id: 1,
                periodico: '',
                cor: "orange",
                titulo: "Assinaturas Hub e impressos",
                descricao: "Soma de assinaturas digital e físico",
                urlApi: "/kpi/assinaturas/total",
                nomeCampo: "assinaturas",
                flagAcessos: false,
                isLoading: false,
            }
        ]

        this.mockKpisRelacionamento = [
            {
                id: 6,
                periodico: 'CRs',
                cor: "danger",
                titulo: "Acesso ao portal EBS e BS+",
                descricao: "",
                urlApi: "/kpi/acessos/total",
                nomeCampo: "acessos",
                flagAcessos: false,
                isLoading: false
            },
            {
                id: 2,
                periodico: 'CRs',
                cor: "danger",
                titulo: "Assinantes dos produtos",
                descricao: "",
                urlApi: "/kpi/assinantes/total",
                nomeCampo: "assinantes",
                flagAcessos: false,
                isLoading: false,
            }
        ]
    }

    componentDidMount() {
        this.setState({
            listaKpisPublicacoes: this.mockKpisPublicacoes,
            listaKpisMarketing: this.mockKpisMarketing,
            listaKpisRelacionamento: this.mockKpisRelacionamento
        })
    }

    carregarKpis(id, area, sigla, flagLoading) {
        let indexKpi;
        // let filterKpi = this.state["listaKpis" + area].filter(item => item.id === id)
        if (!!sigla) {
            // filterKpi = this.state["listaKpis" + area].filter(item => item.sigla === sigla)
            indexKpi = this.state["listaKpis" + area].findIndex(item => item.id === id && item.sigla === sigla)
        } else {
            indexKpi = this.state["listaKpis" + area].findIndex(item => item.id === id)
        }
        if (!flagLoading) {
            this.setState({
                ["listaKpis" + area]: update(this.state["listaKpis" + area], { [indexKpi]: { isLoading: { $set: true } } })
            });
        }
        const { urlApi, nomeCampo } = this.state["listaKpis" + area][indexKpi];
        axios.get(this.Configurations.apiBasePath + urlApi).then(response => {
            let bsMais, hub;
            if (!!response.data.acessos && Array.isArray(response.data.acessos)) {
                bsMais = response.data.acessos.filter(item => item.plataforma === "BS+")[0];
                hub = response.data.acessos.filter(item => item.plataforma === "HUB")[0];
            }
            this.setState({
                ["listaKpis" + area]: update(this.state["listaKpis" + area], {
                    [indexKpi]: {
                        dados: {
                            $set: {
                                numeroAnterior: response.data[nomeCampo],
                                bsMais: bsMais,
                                hub: hub,
                                mes: response.data.mes,
                                data: `${moment(response.data.data).format("DD/MM/YYYY")}`,
                                edicao: response.data.edicao
                            }
                        }
                    }
                })
            })
        }).catch(this.handleError).finally(() => {
            this.setState({
                ["listaKpis" + area]: update(this.state["listaKpis" + area], { [indexKpi]: { isLoading: { $set: false } } })
            })
        })
    }

    carregarTodosKpisPublicacoes() {
        let arrayAux = this.state.listaKpisPublicacoes;
        arrayAux = arrayAux.map(item => {
            return {
                ...item, isLoading: true
            }
        })
        this.setState({
            listaKpisPublicacoes: arrayAux
        })
        this.carregarKpis(3, "Publicacoes", "BS", true);
        this.carregarKpis(3, "Publicacoes", "TC", true);
        this.carregarKpis(7, "Publicacoes", "TC", true);
        this.carregarKpis(3, "Publicacoes", "RD", true);
        this.carregarKpis(4, "Publicacoes", "", true);
    }

    carregarKpisMarketing() {
        let arrayAux = this.state.listaKpisMarketing;
        arrayAux = arrayAux.map(item => {
            return {
                ...item, isLoading: true
            }
        })
        this.setState({
            listaKpisMarketing: arrayAux
        })
        this.carregarKpis(1, "Marketing", "", true);
    }

    carregarKpisRelacionamento() {
        let arrayAux = this.state.listaKpisRelacionamento;
        arrayAux = arrayAux.map(item => {
            return {
                ...item, isLoading: true
            }
        })
        this.setState({
            listaKpisRelacionamento: arrayAux
        })
        this.carregarKpis(6, "Relacionamento", "", true);
        this.carregarKpis(2, "Relacionamento", "", true);

    }

    handleError(err) {
        this.setState({
            hasError: true,
            errorMessage: err.response ?
                (!!err.response.data.message ? err.response.data.message : 'Erro inesperado.') :
                !!err.message ?
                    err.message :
                    'Erro inesperado.'
        })
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: '' })
    }

    render() {
        return (
            <div className='row no-gutters'>
                <div className='col-12 border-bottom border-gray'>
                    <h2>KPIs</h2>
                </div>
                <div className='col-12 text-center'>
                    <div className='row no-gutters'>
                        <div className='col-12 py-3'>
                            <h4><span className='badge badge-primary'>Publicações</span></h4>
                        </div>
                        <div className='col-12 text-center'>
                            <button className='btn btn-outline-success' type="button" name="carregar-kpis-publicacoes" onClick={() => this.carregarTodosKpisPublicacoes()}>Carregar kpis</button>

                            <div className='row no-gutters'>
                                <div className='col-12 text-center'>
                                    <div className='row no-gutters'>
                                        {this.state.listaKpisPublicacoes.length > 0 && this.state.listaKpisPublicacoes.map((item, index) => {
                                            return (
                                                <div className='col-4 align-self-center m-auto' key={index}>
                                                    <KpisAreas
                                                        itemMock={item}
                                                        kpi={item.dados}
                                                        isLoadingKpi={item.isLoading}
                                                        carregarKpi={this.carregarKpis}
                                                        area={"Publicações"}
                                                    />
                                                </div>
                                            )
                                        })}
                                    </div>

                                </div>
                            </div>
                            <div className='col-12 border-bottom border-gray py-3'></div>
                            <div className='col-12 py-2'>
                                <h4><span className='badge badge-orange'>Marketing</span></h4>
                            </div>
                            <button className='btn btn-outline-success' type="button" name="carregar-kpis-marketing" onClick={() => this.carregarKpisMarketing()}>Carregar kpis</button>
                            <div className='col-12 text-center py-2'>
                                <div className='row no-gutters'>
                                    <div className='col-12 text-center'>
                                        <div className='row no-gutters'>
                                            {this.state.listaKpisMarketing.length > 0 && this.state.listaKpisMarketing.map((item, index) => {
                                                return (
                                                    <div className='col-4 align-self-center m-auto' key={index}>
                                                        <KpisAreas
                                                            itemMock={item}
                                                            kpi={item.dados}
                                                            isLoadingKpi={item.isLoading}
                                                            carregarKpi={this.carregarKpis}
                                                            area={"Marketing"}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 border-bottom border-gray py-3'></div>
                            <div className='col-12 py-3'>
                                <h4><span className='badge badge-danger'>Relacionamento</span></h4>
                            </div>
                            <button className='btn btn-outline-success' type="button" name="carregar-kpis-marketing" onClick={() => this.carregarKpisRelacionamento()}>Carregar kpis</button>
                            <div className='col-12 text-center py-2'>
                                <div className='row no-gutters'>
                                    <div className='col-12 text-center'>
                                        <div className='row no-gutters'>
                                            {this.state.listaKpisRelacionamento.length > 0 && this.state.listaKpisRelacionamento.map((item, index) => {
                                                return (
                                                    <div className='col-4 align-self-center m-auto'key={index}>
                                                        <KpisAreas
                                                            itemMock={item}
                                                            kpi={item.dados}
                                                            isLoadingKpi={item.isLoading}
                                                            carregarKpi={this.carregarKpis}
                                                            area={"Relacionamento"}
                                                        />
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ErrorModal
                            isOpen={this.state.hasError}
                            message={this.state.errorMessage}
                            closeErrorModal={this.closeErrorModal}
                            goBack={!this.state.hasError}
                        />
                    </div>
                </div>
            </div>
        )
    }
}


export default Kpis;